.cardSummaryGroup {
  --ixf-card-summary-group-background: var(--ixf-color-neutral-xlt);

  border: 1px solid var(--ixf-color-separator);

  .header {
    padding: var(--ixf-space-2) var(--ixf-space-4);
    border-bottom: 1px solid var(--ixf-color-separator);
    border-top-left-radius: var(--ixf-border-radius-2);
    border-top-right-radius: var(--ixf-border-radius-2);
    background: var(--ixf-card-summary-group-background);

    svg {
      height: 16px;
    }
  }

  .headerOnNeutral {
    --ixf-card-summary-group-background: var(--ixf-color-background);
  }
}

.paddedContainer {
  padding: 0 var(--ixf-space-4);
}
